import { Link } from "gatsby"
import { default as React } from "react"
import {
  connectStateResults,
  Highlight,
  Hits,
  Index,
  Snippet,
  PoweredBy,
} from "react-instantsearch-dom"

const HitCount = connectStateResults(({ searchResults }) => {
  const hitCount = searchResults && searchResults.nbHits

  return hitCount > 0 ? (
    <div className="HitCount">
    <strong>{`${searchResults.index}`}</strong>{`: `}
      {hitCount} result{hitCount !== 1 ? `s` : ``}
    </div>
  ) : null
})

const PageHit = ({ hit }) => {
    return (
        <div>
    <Link to={hit.url}>
      <h4>
        <Highlight attribute="page_title" hit={hit} tagName="mark" />
      </h4>
    </Link>
    <Highlight attribute="first_publication_date" hit={hit} tagName="mark" />
    <Snippet attribute="post_excerpt" hit={hit} tagName="mark" />
    <Snippet attribute="page_content" hit={hit} tagName="mark" />
  </div>
    )
}
    
  

const HitsInIndex = ({ index }) => (
  <Index indexName={index.name}>
    <HitCount />
    <Hits className="Hits" hitComponent={PageHit} />
  </Index>
)

const SearchResult = ({ indices, className }) => (
  <div className={className}>
    {indices.map(index => (
      <HitsInIndex index={index} key={index.name} />
    ))}
    <PoweredBy />
  </div>
)

export default SearchResult